import { Dispatch, SetStateAction } from "react";

import { TableColumn } from "@/components/Table/Table";
import { SortParams } from "@/types/types";

import {
	renderContactSelectColumn,
	renderProspectNameColumn,
	renderProspectCompanyColumn,
	renderProspectSeniorityColumn,
	renderProspectLocationColumn,
	renderContactJobTitleColumn,
	renderContactPersonCountryColumn,
	renderContactCompanyCountryColumn,
	renderContactCompanyIndustryColumn,
	renderContactCompanySizeColumn,
	renderContactCompanyFoundedYearColumn,
	renderContactGenderColumn,
	renderContactSalutationDeColumn,
	renderContactSalutationEnColumn,
	renderContactLeadScoringColumn,
	renderContactCompanyCategoryColumn,
	renderContactPersonaCategoryColumn,
	renderContactListsColumn,
} from "../../../Contacts/utils/allColumns";
import {
	renderBlacklistAddedByColumn,
	renderBlacklistAddedToBlacklistAtColumn,
	renderBlacklistDetectedByColumn,
	renderBlacklistOriginColumn,
	renderBlacklistRemoveColumn,
	renderBlacklistSnoozedColumn,
	renderBlacklistSnoozedUntilColumn,
	renderBlacklistSourceColumn,
} from "../../utils/blacklistColumns";
import { renderBlacklistUnflagCompetitorColumn } from "../../utils/competitorColumns";

export interface BlacklistTableColumnsProps {
	handleCopyClick: (value: string) => void;
	ts: (key: string) => string;
	sortingInbox: SortParams;
	setShowAll: Dispatch<SetStateAction<boolean>>;
	toggleSelectAll: () => void;
	selectAll: boolean;
	selectedItems: number[];
	handleSelectItem: (id: number) => void;
	onUnflagCompetitor: (organizationId: number, companyName?: string) => void;
	onRemoveFromBlacklist: (rowId: number) => void;
}

// No-op for inline editing — blacklist rows are read-only
const noopSetShowEdit = () => {};

export const BlacklistTableColumns = ({
	handleCopyClick,
	ts,
	sortingInbox,
	setShowAll,
	toggleSelectAll,
	selectAll,
	selectedItems,
	handleSelectItem,
	onUnflagCompetitor,
	onRemoveFromBlacklist,
}: BlacklistTableColumnsProps): TableColumn[] => {
	return [
		renderContactSelectColumn(
			setShowAll,
			toggleSelectAll,
			selectAll,
			selectedItems,
			handleSelectItem
		),
		// The ticket's order: who/where first, then the verdict and the way out of it, then the
		// attribution — everything else the tab already offered stays behind those.
		renderProspectNameColumn(ts, handleCopyClick, sortingInbox, noopSetShowEdit, undefined),
		renderProspectCompanyColumn(ts, handleCopyClick, sortingInbox, noopSetShowEdit, undefined),
		renderBlacklistOriginColumn(ts, sortingInbox),
		renderBlacklistUnflagCompetitorColumn(ts, onUnflagCompetitor),
		renderBlacklistRemoveColumn(ts, onRemoveFromBlacklist),
		renderBlacklistDetectedByColumn(ts),
		renderBlacklistAddedByColumn(ts),
		renderBlacklistAddedToBlacklistAtColumn(ts, sortingInbox),
		renderContactLeadScoringColumn(ts, sortingInbox),
		renderBlacklistSourceColumn(ts, sortingInbox),
		renderBlacklistSnoozedColumn(ts),
		renderBlacklistSnoozedUntilColumn(ts),
		renderContactJobTitleColumn(ts, handleCopyClick, sortingInbox),
		renderContactGenderColumn(ts, handleCopyClick, sortingInbox, noopSetShowEdit, undefined),
		renderContactSalutationDeColumn(ts),
		renderContactSalutationEnColumn(ts),
		renderContactPersonCountryColumn(ts, handleCopyClick, sortingInbox),
		renderContactCompanyCountryColumn(ts, handleCopyClick, sortingInbox),
		renderContactCompanyIndustryColumn(ts, handleCopyClick, sortingInbox),
		renderContactCompanySizeColumn(ts, handleCopyClick, sortingInbox),
		renderContactCompanyFoundedYearColumn(ts, handleCopyClick, sortingInbox),
		renderContactCompanyCategoryColumn(ts, sortingInbox),
		renderContactPersonaCategoryColumn(ts, sortingInbox),
		renderContactListsColumn(ts),
		renderProspectSeniorityColumn(ts, sortingInbox),
		renderProspectLocationColumn(ts, handleCopyClick, sortingInbox),
	];
};
